import { MouseEvent, useState } from 'react';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';

import FundMovementsModal from './FundMovementsModal';

interface FollowedFundActionsMenuProps {
  operationId: string;
  competenceDate: string;
}

export function FollowedFundActionsMenu({
  operationId,
  competenceDate,
}: FollowedFundActionsMenuProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isMovementsModalOpen, setIsMovementsModalOpen] = useState(false);
  const menuId = `followed-fund-actions-menu-${operationId}`;

  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleMovement = () => {
    handleCloseMenu();
    setIsMovementsModalOpen(true);
  };

  return (
    <>
      <IconButton
        aria-label="Ações do fundo"
        aria-controls={anchorEl ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={anchorEl ? 'true' : undefined}
        onClick={handleOpenMenu}
        size="small">
        <MoreVertIcon />
      </IconButton>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}>
        <MenuItem onClick={handleMovement}>
          <ListItemIcon>
            <SyncAltIcon fontSize="small" color="primary" />
          </ListItemIcon>
          Movimentação
        </MenuItem>
      </Menu>
      {isMovementsModalOpen && (
        <FundMovementsModal
          open={isMovementsModalOpen}
          onClose={() => setIsMovementsModalOpen(false)}
          operationId={operationId}
          competenceDate={competenceDate}
        />
      )}
    </>
  );
}
